import { PageType } from '@core/enums';
import { API_URLS } from '@helpers/api';
import { ThemeOption } from '@helpers/brand';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import ArticleCard from '@stories/Components/Cards/ArticleCard/ArticleCard';
import EventCard from '@stories/Components/Cards/EventCard/EventCard';
import ResourceCard from '@stories/Components/Cards/ResourceCard/ResourceCard';
import FilteredListing from '@stories/Components/Filters/FilteredListing/FilteredListing';
import queryString from 'query-string';
import React from 'react';
import { ArrayParam, NumberParam, StringParam, useQueryParams, withDefault, } from 'use-query-params';
import { ArticleListingStyles as S } from './ArticleListing.styles';
const ArticleListing = ({ dataApiUrl = API_URLS.ARTICLE_LIST, content, featuredItem, filterHeading, filters, quickFilters, hideImages = false, id, initialData, errorText, pageContext, pageIds, pageType, theme = ThemeOption.Orange, translations, isTalksOnDemandPage = false, }) => {
    // Define query string parameters.
    const [queryParams, setQueryParams] = useQueryParams({
        pageIndex: withDefault(NumberParam, 1),
        filter: withDefault(ArrayParam, initialData.filter ?? []),
        searchTerm: StringParam,
        sortBy: StringParam,
    });
    const [activeFilters, setActiveFilters] = React.useState(initialData.filter ? initialData.filter : queryParams.filter ?? null);
    // Get page index or default.
    const pageIndex = queryParams.pageIndex ?? 1;
    const pageSize = 12;
    // Get filter or default.
    const filterValue = queryParams.filter;
    // Construct API url.
    const parameters = queryString.stringify({
        docId: pageContext?.documentId,
        pageType,
        filter: filterValue,
        pageIndex: pageIndex,
        pageSize: pageSize,
        searchTerm: queryParams.searchTerm,
        ...(pageIds && { pageIds }), // Only include pageIds if provided
    });
    const apiUrl = `${dataApiUrl}?${parameters}`;
    // Fetch data.
    const { data, error, complete } = useApi(apiUrl);
    // Get items from response or initial items.
    const items = data?.items ?? initialData.items;
    const totalItems = data?.totalItems ?? initialData.totalItems;
    React.useEffect(() => {
        if (activeFilters) {
            setQueryParams({ filter: activeFilters, pageIndex: undefined });
        }
        else {
            setQueryParams({ filter: [], pageIndex: undefined });
        }
    }, [activeFilters, setQueryParams]);
    return (React.createElement(React.Fragment, null,
        content && (React.createElement(S.Container, { innerWidth: "narrow", flush: "top" },
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }))),
        React.createElement(S.Container, { innerWidth: "reduced", flush: content ? undefined : 'top', id: id, theme: theme },
            featuredItem &&
                (() => {
                    switch (pageType) {
                        case PageType.News:
                            return React.createElement(ArticleCard, { ...featuredItem, theme: theme });
                        case PageType.Events:
                            return (React.createElement(EventCard, { ...featuredItem, theme: theme, isTalksOnDemandPage: isTalksOnDemandPage }));
                        case PageType.Resources:
                        case PageType.CGeogMembers:
                            return React.createElement(ResourceCard, { ...featuredItem, theme: theme });
                    }
                })(),
            React.createElement(FilteredListing, { filterProps: {
                    checkboxFilters: filters,
                    quickFilters: quickFilters,
                    activeFilter: filterValue ?? [],
                    dropdownFilterValue: filterValue ?? [],
                    filterHeading: filterHeading,
                    onCheckboxChange: (name, filterValue) => {
                        let filters = activeFilters;
                        if (filters && activeFilters) {
                            if (filters.includes(filterValue)) {
                                filters = activeFilters.filter((x) => x !== filterValue);
                            }
                            else {
                                filters = [...activeFilters, filterValue];
                            }
                            setActiveFilters(filters);
                        }
                        else {
                            setActiveFilters([filterValue]);
                        }
                    },
                    keywordSearchHandler: (value) => {
                        setQueryParams({ searchTerm: value, pageIndex: 1 }, 'pushIn');
                    },
                    searchTerm: queryParams.searchTerm,
                    translations,
                }, errorText: errorText, error: error, items: items, complete: complete, pageSize: pageSize, pageIndex: pageIndex, renderItems: (items) => (React.createElement(S.Listing, null, (() => {
                    switch (pageType) {
                        case PageType.News:
                            return items.map((item, index) => (React.createElement(ArticleCard, { key: `item-${index}`, hideImage: hideImages, ...item, theme: theme })));
                        case PageType.Events:
                            return items.map((item, index) => (React.createElement(EventCard, { key: `item-${index}`, hideImage: hideImages, ...item, theme: theme, isTalksOnDemandPage: isTalksOnDemandPage })));
                        case PageType.Resources:
                        case PageType.CGeogMembers:
                            return items.map((item, index) => (React.createElement(ResourceCard, { key: `item-${index}`, hideImage: hideImages, ...item, theme: theme })));
                    }
                })())), totalItems: totalItems, onPageChange: (pageIndex) => {
                    setQueryParams({ pageIndex });
                }, onReset: () => {
                    setActiveFilters(null);
                } }))));
};
export default withQueryParams(ArticleListing);
